import DiamondFilled from '../../src/legacy/DiamondFilled';
export default DiamondFilled;
